/* PLAYLIST ACTIONS ***********************************************************/

// libs
import Cookies from 'js-cookie'
import _ from 'lodash'

// rest webservice api abstraction
import * as api from 'api'

// actions
import { showModal, hideModal } from 'react-redux/actions/modal'
import { fetchItem as fetchAsset } from 'react-redux/actions/asset'
import { setSyncHintByPlaylist } from 'react-redux/actions/media-player'
import { findRelated, select } from 'react-redux/actions/highlight'
import { push as pushNotification } from 'react-redux/actions/notification'

// selectors
import { getItem as getPlaylistItem, getEditItem } from 'react-redux/selectors/playlist'
import { getItem as getAssetItem } from 'react-redux/selectors/asset'

// utils
import { getDuration } from 'util/asset'
//import { isVideoAsset, isImageAsset } from 'util/file'

// constants import
import * as notificationType from 'component/notification/type'



import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'


export const makePlaylistPayload = (getState, uid) => {
  return _.cloneDeep(
   _.pick(
     getPlaylistItem(getState(), uid),
     ["mediaObjects", "fallback", "timeConstraint", "name", "tags"]
   )
 )
}

export const makeEmptyPlaylist = (name, tags) => {
  return {
    name: name,
    tags: tags || [],
    mediaObjects: [],
    fallback: null,
    timeConstraint :  {
      startTime: "",
      stopTime:  ""
    }
  }
}

export const makeMediaObject = (getState, assetId) => {
  const asset = getAssetItem(getState(), assetId)
  const duration = getDuration(asset)
  return {
    assetId : assetId,
    duration: duration,
    timeConstraint: {startTime: "", stopTime: ""},
    schedule: {weekday: []}
  }
}

/* FETCH PLAYLIST ITEMS *******************************************************/

export const FETCH_ITEMS = 'playlist/list/FETCH_ITEMS'
export const fetchItems = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { sort, pagination, pendingQuery } = state.playlist.list
    if (!pendingQuery){
      if (!params.hasOwnProperty("max_results"))
        params.max_results = pagination.maxResults
      if (!params.hasOwnProperty("page"))
        params.page = pagination.page
      if (!params.hasOwnProperty("sort_by_field"))
        params.sort_by_field = sort.field
      if (!params.hasOwnProperty("reverse_order"))
        params.reverse_order = sort.reverse[sort.field]
      dispatch(makeAction(FETCH_ITEMS, params))
    }
  }
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEMS_FAIL = FETCH_ITEMS + FAIL_SUFFIX
export const FETCH_ITEMS_SUCCESS = FETCH_ITEMS + SUCCESS_SUFFIX

export const NEXT_PAGE = 'playlist/list/NEXT_PAGE'
export const nextPage = () => {
  return makeAction(NEXT_PAGE)
}

/* FETCH SINGLE ITEM **********************************************************/

export const FETCH_ITEM = 'playlist/list/FETCH_ITEM'
export const fetchItem = (uid) => {
  return makeAction(FETCH_ITEM,{uid})
}
/* automated for convenience @see dataprovider */
export const FETCH_ITEM_FAIL = FETCH_ITEM + FAIL_SUFFIX
export const FETCH_ITEM_SUCCESS = FETCH_ITEM + SUCCESS_SUFFIX

/* CREATE EMPTY PLAYLIST ******************************************************/

export const CREATE_EMPTY_PLAYLIST  = 'playlist/edit/CREATE_EMPTY_PLAYLIST'
export const createEmptyPlaylist = (name) => {
  return (dispatch, getState) => {
    const state = getState()
    let tags = []
    const expression = state.app.filter.expression
    if (expression) {
      const matches = expression.match(/#[^ ]+/g)
      if (matches) tags = matches.map(x=>x.replace('#',''))
    }
    dispatch(makeAction(CREATE_EMPTY_PLAYLIST, makeEmptyPlaylist(name, tags)))
  }
}
/* automated for convenience @see dataprovider */
export const CREATE_EMPTY_PLAYLIST_FAIL = CREATE_EMPTY_PLAYLIST + FAIL_SUFFIX
export const CREATE_EMPTY_PLAYLIST_SUCCESS = CREATE_EMPTY_PLAYLIST + SUCCESS_SUFFIX

/* DELETE SINGLE PLAYLIST *****************************************************/

export const DELETE_SINGLE_ITEM = 'playlist/edit/DELETE_SINGLE_ITEM'
export const deleteSingleItem = (uid) => {
  return (dispatch, getState) => {
    const mediaObjects = getState().playlist.list.items[uid].mediaObjects
    const affectedAssets = mediaObjects.map(o => o.assetId)
    return dispatch(makeAction(DELETE_SINGLE_ITEM, {uid}, {affectedAssets}))
  }
}
/* automated for convenience @see dataprovider */
export const DELETE_SINGLE_ITEM_FAIL = DELETE_SINGLE_ITEM + FAIL_SUFFIX
export const DELETE_SINGLE_ITEM_SUCCESS = DELETE_SINGLE_ITEM + SUCCESS_SUFFIX

/* CHANGE PLAYLIST NAME *******************************************************/

export const SAVE_NAME  = 'playlist/edit/SAVE_NAME'
export const saveName = (uid, name) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.name = name
    dispatch(makeAction(SAVE_NAME, { uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_NAME_FAIL = SAVE_NAME + FAIL_SUFFIX
export const SAVE_NAME_SUCCESS = SAVE_NAME + SUCCESS_SUFFIX

/* SAVE PLAYLIST TAGS *********************************************************/
export const SAVE_TAGS  = 'playlist/edit/SAVE_TAGS'
export const saveTags = (uid, tags) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.tags = tags
    dispatch(makeAction(SAVE_TAGS, { uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_TAGS_FAIL = SAVE_TAGS + FAIL_SUFFIX
export const SAVE_TAGS_SUCCESS = SAVE_TAGS + SUCCESS_SUFFIX

/* CHANGE PLAYLIST START TIME *************************************************/

export const SAVE_START_TIME = 'playlist/edit/SAVE_START_TIME'
export const saveStartTime = (uid, startTime) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.timeConstraint.startTime = startTime
    dispatch(makeAction(SAVE_START_TIME, { uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_START_TIME_FAIL = SAVE_START_TIME + FAIL_SUFFIX
export const SAVE_START_TIME_SUCCESS = SAVE_START_TIME + SUCCESS_SUFFIX

/* CHANGE PLAYLIST STOP TIME **************************************************/

export const SAVE_STOP_TIME = 'playlist/edit/SAVE_STOP_TIME'
export const saveStopTime = (uid, stopTime) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.timeConstraint.stopTime = stopTime
    dispatch(makeAction(SAVE_STOP_TIME, { uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_STOP_TIME_FAIL = SAVE_STOP_TIME + FAIL_SUFFIX
export const SAVE_STOP_TIME_SUCCESS = SAVE_STOP_TIME + SUCCESS_SUFFIX

/* DUPLICATE PLAYLIST *********************************************************/

export const DUPLICATE = 'playlist/edit/DUPLICATE'
export const duplicate = (uid) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    dispatch(makeAction(DUPLICATE, item))
  }
}
/* automated for convenience @see dataprovider */
export const DUPLICATE_FAIL = DUPLICATE + FAIL_SUFFIX
export const DUPLICATE_SUCCESS = DUPLICATE + SUCCESS_SUFFIX



/* PLAYLIST FILTER ************************************************************/

/* Fetch */
export const FETCH_FILTER = 'playlist/list/FETCH_FILTER'
export const fetchFilter = (filter) => {
  return makeAction(FETCH_FILTER, filter)
}
/* automated for convenience @see dataprovider */
export const FETCH_FILTER_FAIL = FETCH_FILTER + FAIL_SUFFIX
export const FETCH_FILTER_SUCCESS = FETCH_FILTER + SUCCESS_SUFFIX

/* Save */
export const SAVE_FILTER = 'playlist/list/SAVE_FILTER'
export const saveFilter = (filter) => {
  return makeAction(SAVE_FILTER, filter)
}
/* automated for convenience @see dataprovider */
export const SAVE_FILTER_FAIL = SAVE_FILTER + FAIL_SUFFIX
export const SAVE_FILTER_SUCCESS = SAVE_FILTER + SUCCESS_SUFFIX

/* SORT ***********************************************************************/

/* Fetch */
export const FETCH_SORT = 'playlist/list/FETCH_SORT'
export const fetchSort = () => {
  return makeAction(FETCH_SORT)
}
/* automated for convenience @see dataprovider */
export const FETCH_SORT_FAIL = FETCH_SORT + FAIL_SUFFIX
export const FETCH_SORT_SUCCESS = FETCH_SORT + SUCCESS_SUFFIX

/* Save */
export const SAVE_SORT = 'playlist/list/SAVE_SORT'
export const saveSort = (sort) => {
  return makeAction(SAVE_SORT, sort)
}
/* automated for convenience @see dataprovider */
export const SAVE_SORT_FAIL = SAVE_SORT + FAIL_SUFFIX
export const SAVE_SORT_SUCCESS = SAVE_SORT + SUCCESS_SUFFIX

/* EXPAND AND COLLAPSE ********************************************************/
export const COLLAPSE = 'playlist/list/COLLAPSE'
export const collapse = (uid) => {
return (dispatch) => {
  dispatch({ type: COLLAPSE, uid })
    let expanded = {}
    if(localStorage.playlistExpanded)
        expanded = JSON.parse(localStorage.playlistExpanded)
    delete expanded[uid]
    localStorage.playlistExpanded = JSON.stringify(expanded)
  }
}

export const EXPAND = 'playlist/list/EXPAND'
export const expand = (uid) => {
return (dispatch) => {
  dispatch({ type: EXPAND, uid })
    let expanded = {}
    if(localStorage.playlistExpanded)
      expanded = JSON.parse(localStorage.playlistExpanded)
    expanded[uid] = true
    localStorage.setItem("playlistExpanded", JSON.stringify(expanded))
  }
}

export const SET_EXPANDED = 'playlist/list/SET_EXPANDED'
export const setExpanded = (expanded) => {
return { type: SET_EXPANDED, expanded }
}

export const FETCH_EXPANDED = 'playlist/list/FETCH_EXPANDED'
export const fetchExpanded = (uid) => {
return (dispatch) => {
  dispatch({ type: FETCH_EXPANDED, uid })
    let expanded = {}
    if(localStorage.playlistExpanded)
      expanded = JSON.parse(localStorage.playlistExpanded)
    //dispatch(setExpanded(expanded))
  }
}

/* PLAYLIST ASSETS */

/* SAVE PLAYLIST ASSET START TIME *********************************************/

export const SAVE_ASSET_START_TIME = 'playlist/edit/SAVE_ASSET_START_TIME'
export const saveAssetStartTime = (uid, index, startTime) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.mediaObjects[index].timeConstraint.startTime = startTime
    dispatch(makeAction(SAVE_ASSET_START_TIME, {uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_ASSET_START_TIME_FAIL = SAVE_ASSET_START_TIME + FAIL_SUFFIX
export const SAVE_ASSET_START_TIME_SUCCESS = SAVE_ASSET_START_TIME + SUCCESS_SUFFIX

/* SAVE ASSET STOP TIME *******************************************************/

export const SAVE_ASSET_STOP_TIME = 'playlist/edit/SAVE_ASSET_STOP_TIME'
export const saveAssetStopTime = (uid, index, stopTime) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.mediaObjects[index].timeConstraint.stopTime = stopTime
    dispatch(makeAction(SAVE_ASSET_STOP_TIME, {uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_ASSET_STOP_TIME_FAIL = SAVE_ASSET_STOP_TIME + FAIL_SUFFIX
export const SAVE_ASSET_STOP_TIME_SUCCESS = SAVE_ASSET_STOP_TIME + SUCCESS_SUFFIX

/* SAVE ASSET DURATION ********************************************************/

export const SAVE_ASSET_DURATION = 'playlist/edit/SAVE_ASSET_DURATION'
export const saveAssetDuration = (uid, index, duration) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, uid)
    item.mediaObjects[index].duration = duration
    dispatch(makeAction(SAVE_ASSET_DURATION, {uid, item }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_ASSET_DURATION_FAIL = SAVE_ASSET_DURATION + FAIL_SUFFIX
export const SAVE_ASSET_DURATION_SUCCESS = SAVE_ASSET_DURATION + SUCCESS_SUFFIX

/* SAVE ASSET SCHEDULE ********************************************************/

export const SAVE_ASSET_SCHEDULE = 'playlist/edit/SAVE_ASSET_SCHEDULE'
export const saveAssetSchedule = (uid, index, schedule) => {
  return (dispatch, getState) => {
    //console.log(saveAssetSchedule)
    //const item = makePlaylistPayload(getState, uid)
    const item = makePlaylistPayload(getState, uid)
    item.mediaObjects[index].schedule = schedule
    dispatch(makeAction(SAVE_ASSET_SCHEDULE, {uid, item}))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_ASSET_SCHEDULE_FAIL = SAVE_ASSET_SCHEDULE + FAIL_SUFFIX
export const SAVE_ASSET_SCHEDULE_SUCCESS = SAVE_ASSET_SCHEDULE + SUCCESS_SUFFIX

/* CREATE A NEW PLAYLIST AROUND AN ASSET **************************************/

export const CREATE_PLAYLIST_FROM_ASSET  = 'playlist/edit/CREATE_PLAYLIST_FROM_ASSET'
export const createPlaylistFromAsset = (assetId) => {
  return (dispatch, getState) => {
    const asset = getAssetItem(getState(), assetId)
    const duration = getDuration(asset)
    const mediaObjects = [
      {
        assetId : assetId,
        duration: duration,
        timeConstraint: {startTime: null, stopTime: null}
      }
    ]
    dispatch(makeAction(CREATE_PLAYLIST_FROM_ASSET, {
      name: asset.name,
      tags: [],
      mediaObjects,
      timeConstraint :  {
        startTime: null,
        stopTime:  null
      }
    }))
  }
}
/* automated for convenience @see dataprovider */
export const CREATE_PLAYLIST_FROM_ASSET_FAIL = CREATE_PLAYLIST_FROM_ASSET + FAIL_SUFFIX
export const CREATE_PLAYLIST_FROM_ASSET_SUCCESS = CREATE_PLAYLIST_FROM_ASSET + SUCCESS_SUFFIX


/* APPENDS AN ASSET TO THE END OF A PLAYLIST **********************************/

export const APPEND_ASSET  = 'playlist/edit/APPEND_ASSET'
export const appendAsset = (playlistId, assetId) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, playlistId)
    const asset = getAssetItem(getState(), assetId)
    const duration = getDuration(asset)
    item.mediaObjects.push({
      assetId : assetId,
      duration: duration,
      timeConstraint: {startTime: null, stopTime: null}
    })
    dispatch(makeAction(APPEND_ASSET, { uid: playlistId, item, assetId }))
  }
}
/* automated for convenience @see dataprovider */
export const APPEND_ASSET_FAIL = APPEND_ASSET + FAIL_SUFFIX
export const APPEND_ASSET_SUCCESS = APPEND_ASSET + SUCCESS_SUFFIX


/* ADD AN ASSET AT A SPECIFIC POSITION ****************************************/

export const APPEND_ASSET_AT  = 'playlist/edit/APPEND_ASSET_AT'
export const appendAssetAt = (playlistId, assetId, index) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, playlistId)
    const asset = getAssetItem(getState(), assetId)
    const duration = getDuration(asset)
    item.mediaObjects.splice(
      index,
      0,
      {
        assetId : assetId,
        duration: duration,
        timeConstraint: {startTime: null, stopTime: null}
      }
    )
    dispatch(makeAction(APPEND_ASSET_AT, { uid: playlistId, item, assetId }))
  }
}
/* automated for convenience @see dataprovider */
export const APPEND_ASSET_AT_FAIL = APPEND_ASSET_AT + FAIL_SUFFIX
export const APPEND_ASSET_AT_SUCCESS = APPEND_ASSET_AT + SUCCESS_SUFFIX

/* MOVE PLAYLIST ASSET WITHIN PLAYLIST ****************************************/

export const MOVE_ASSET  = 'playlist/edit/MOVE_ASSET'
export const moveAsset = (playlistId, origin, target) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, playlistId)
    item.mediaObjects.splice(...[target, 0].concat(item.mediaObjects.splice(origin, 1)))
    dispatch(makeAction(MOVE_ASSET, { uid: playlistId, item }))
  }
}
/* automated for convenience @see dataprovider */
export const MOVE_ASSET_FAIL = MOVE_ASSET + FAIL_SUFFIX
export const MOVE_ASSET_SUCCESS = MOVE_ASSET + SUCCESS_SUFFIX

/* REMOVE ASSET FROM PLAYLIST *************************************************/

export const REMOVE_ASSET  = 'playlist/edit/REMOVE_ASSET'
export const removeAsset = (playlistId, index) => {
  return (dispatch, getState) => {
    const item = makePlaylistPayload(getState, playlistId)
    const spliced = item.mediaObjects.splice(index, 1)
    dispatch(makeAction(REMOVE_ASSET, { uid: playlistId, item, assetId: spliced[0].assetId }))
  }
}
/* automated for convenience @see dataprovider */
export const REMOVE_ASSET_FAIL = REMOVE_ASSET + FAIL_SUFFIX
export const REMOVE_ASSET_SUCCESS = REMOVE_ASSET + SUCCESS_SUFFIX

/* REMOVE AN ASSET FROM ONE AN APPEND TO ANOTHER PLAYLIST *********************/

export const REMOVE_AND_APPEND_ASSET  = 'playlist/edit/REMOVE_AND_APPEND_ASSET'
export const removeAndAppendAsset = (origin, index, target) => {
  return (dispatch, getState) => {
    const originItem = makePlaylistPayload(getState, origin)
    const spliced = originItem.mediaObjects.splice(index, 1)
    dispatch(makeAction(REMOVE_AND_APPEND_ASSET, { uid: origin, item:originItem, assetId: spliced[0].assetId, target }))
  }
}
/* automated for convenience @see dataprovider */
export const REMOVE_AND_APPEND_ASSET_FAIL = REMOVE_AND_APPEND_ASSET + FAIL_SUFFIX
export const REMOVE_AND_APPEND_ASSET_SUCCESS = REMOVE_AND_APPEND_ASSET + SUCCESS_SUFFIX

/* REMOVE AN ASSET FROM ONE AND INSERT TO ANOTHER PLAYLIST ********************/

export const REMOVE_AND_INSERT_ASSET  = 'playlist/edit/REMOVE_AND_INSERT_ASSET'
export const removeAndInsertAsset = (origin, index, target, targetIndex) => {
  return (dispatch, getState) => {
    const originItem = makePlaylistPayload(getState, origin)
    const spliced = originItem.mediaObjects.splice(index, 1)
    dispatch(makeAction(REMOVE_AND_INSERT_ASSET, { uid: origin, item:originItem, assetId: spliced[0].assetId, target, targetIndex }))
  }
}
/* automated for convenience @see dataprovider */
export const REMOVE_AND_INSERT_ASSET_FAIL = REMOVE_AND_INSERT_ASSET + FAIL_SUFFIX
export const REMOVE_AND_INSERT_ASSET_SUCCESS = REMOVE_AND_INSERT_ASSET + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/playlist.js